import Icon from '../components/Icon.jsx';
import { ashaReferences } from '../data.js';

const bannerImages = [
  '/assets/asha-reference-adults.jpg',
  '/assets/asha-reference-children.jpg',
];

export default function AshaSlide() {
  return (
    <section className="slide-content asha-slide">
      <div className="section-heading asha-heading reveal-stack">
        <div className="asha-heading-copy">
          <div className="eyebrow dark"><Icon name="book" />ASHA</div>
          <h2>ASHA REFERENCES</h2>
        </div>

        <img
          className="asha-heading-logo"
          src="/assets/asha-logo.webp"
          alt="American Speech-Language-Hearing Association"
        />
      </div>

      <div className="asha-stage">
        <div className="asha-grid">
          {ashaReferences.map((reference, index) => (
            <article className="asha-card" key={reference.title}>
              <div className="asha-card-index">0{index + 1}</div>

              <div
                className="asha-banner"
                style={{ '--banner-image': `url(${bannerImages[index % bannerImages.length]})` }}
              >
                <div className="asha-banner-overlay" />
                <div className="asha-banner-text">
                  <span>American Speech-Language-Hearing Association</span>
                  <b>ASHA</b>
                </div>
              </div>

              <div className="asha-body">
                <h3>{reference.title}</h3>
                <p>{reference.body}</p>
                <small>American Speech-Language-Hearing Association</small>
                <a className="asha-link" href={reference.url} target="_blank" rel="noreferrer">
                  Open ASHA reference <Icon name="arrow" />
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
